import { createContext, useContext, useState } from 'react'

type UploadFilesStore = {
  files: File[]
  urls: string[]
  filesIds: number[]
  addFile: (file: File) => void
  addFiles: (files: File[]) => void
  addUrl: (url: string) => void
  setFilesIds: (filesIds: number[]) => void
  clear: () => void
  removeFileIndex: (idx: number) => void
  removeUrlIndex: (idx: number) => void
  removeFileIdIndex: (idx: number) => void
}

const UploadFilesContext = createContext<UploadFilesStore>({
  files: [],
  urls: [],
  filesIds: [],
  addFile: () => {},
  addFiles: () => {},
  addUrl: () => {},
  clear: () => {},
  removeFileIndex: () => {},
  removeUrlIndex: () => {},
  setFilesIds: () => {},
  removeFileIdIndex: () => {},
})

export const useUploadFiles = () => useContext(UploadFilesContext)

export function UploadFilesProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [files, setFiles] = useState<File[]>([])
  const [urls, setUrl] = useState<string[]>([])
  const [filesIds, setFilesIds] = useState<number[]>([])

  return (
    <UploadFilesContext.Provider
      value={{
        files,
        urls,
        filesIds,
        addFile: (file) => {
          setFiles((prev) => [...prev, file])
        },
        addFiles: (files) => {
          setFiles((prev) => [...prev, ...files])
        },
        addUrl: (url) => {
          setUrl((prev) => [...prev, url])
        },
        clear: () => {
          setFiles([])
          setUrl([])
        },
        removeFileIndex: (index) => {
          setFiles(files.filter((_, i) => i !== index))
        },
        removeUrlIndex: (index) => {
          setUrl(urls.filter((_, i) => i !== index))
        },
        removeFileIdIndex: (index) => {
          setFilesIds(filesIds.filter((_, i) => i !== index))
        },
        setFilesIds,
      }}>
      {children}
    </UploadFilesContext.Provider>
  )
}
